import { ShaderStore } from "@babylonjs/core";
const name = "textureDepthFragmentDeclaration";
const shader = `uniform highp sampler2DArray uTextures;in vec2 vUvs;flat in float depth;`;
ShaderStore.IncludesShadersStore[name] = shader;
export const textureDepthFragmentDeclaration = { name, shader };
//# sourceMappingURL=textureDepthFragmentDeclaration.js.map